/**
 * 登录页壳层布局决策（纯函数，便于多端兼容逻辑集中测试与维护）
 */

/**
 * @param {{ useLegacyLayout: boolean, videoFailed: boolean, isDesktop: boolean, isTablet: boolean, isLandscape: boolean }} ctx
 */
export function shouldShowLoginVideo ({
  useLegacyLayout,
  videoFailed,
  isDesktop,
  isTablet,
  isLandscape
}) {
  if (useLegacyLayout || videoFailed) return false
  return isDesktop || (isTablet && isLandscape)
}

/**
 * @param {{ useLegacyLayout: boolean, isDesktop: boolean, isTablet: boolean, isLandscape: boolean }} ctx
 */
export function shouldUseSidePanelLayout ({
  useLegacyLayout,
  isDesktop,
  isTablet,
  isLandscape
}) {
  if (useLegacyLayout) return false
  return isDesktop || (isTablet && isLandscape)
}

/** @param {{ isTablet: boolean, isLandscape: boolean }} ctx */
export function resolveSidePanelVariant ({ isTablet, isLandscape }) {
  if (isTablet && isLandscape) return 'tablet'
  return 'desktop'
}

/** @returns {boolean} */
export function detectLandscape () {
  if (typeof window === 'undefined') return false
  return window.innerWidth > window.innerHeight
}
